/*
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { InjectionToken } from '@angular/core';
export var NB_TREE_GRID = new InjectionToken('NB_TREE_GRID');
//# sourceMappingURL=tree-grid-injection-tokens.js.map